// {{{ Startup

GW.ready(function() {
        // check for stylesheet changes and reload styles automatically
        function reloadStyles() {
                document.querySelectorAll('link[rel=stylesheet]').forEach(el => {
                        if (!el.origHref) {
                                el.origHref = el.href;
                        }

                        el.href = el.origHref + '?_ts=' + new Date().getTime();
                });
        }
                                
        window.addEventListener('keydown', ev => {
                if (ev.key == 'F4') {
                        ev.preventDefault();
                        reloadStyles();
                }
        }, true);

        window.onerror = async function(msg, url, line, pos, err) {
		try {
			await REST.POST('/api/log', {
				name: err.name,
				message: err.message,
				file: err.fileName + '[' + err.lineNumber + ',' + err.columnNumber+ ']',
				stack: (err.stack || '').split('\n'),
				url: location.href,
				ua: navigator.userAgent,
			});
		} catch(ex) {
		}
        };
                        
        window.onunhandledrejection = async ev => {
		if (ev.reason instanceof RESTError) {
			Application.notify({
				kind: 'error',
				text: ev.reason.message,
				priority: 5,
				timeout: 5000,
			});

			if (ev.reason.status == 401 && Application.onUnathorizedError) {
				Application.onUnathorizedError(ev.reason);
			}
		} else if (ev.reason instanceof Error) {
			Application.notify({
				kind: 'error',
				text: ev.reason.message || _('Unhandled rejection'),
				priority: 5,
				timeout: 5000,
			});

			try {
				let err = ev.reason;

				await REST.POST('/api/log', {
					name: err.name,
					message: err.message,
					file: err.fileName + '[' + err.lineNumber + ',' + err.columnNumber+ ']',
					stack: (err.stack || '').split('\n'),
					url: location.href,
					ua: navigator.userAgent,
				});
			} catch(ex) {
			}
		}
        };

        Application.run();
});
                        
// }}}
